import { render, staticRenderFns } from "./ButtonClose.vue?vue&type=template&id=8f9bbbca&"
import script from "./ButtonClose.ts?vue&type=script&lang=ts&"
export * from "./ButtonClose.ts?vue&type=script&lang=ts&"
import style0 from "./ButtonClose.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports